<template>
    <div>
        <Modal
            v-model="modal"
            title="验证"
            :width="342"
            :mask-closable="false"
        >
            <slideverify ref="verify" :l="42" :r="10" :w="310" :h="155" @success="onSuccess" @fail="onFail"
                         @refresh="onRefresh"
                         :slider-text="text"></slideverify>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
    import slideverify from './slide-verify/slide-verify'

    export default {
        components: {
            slideverify
        },
        data() {
            return {
                text: '向右滑',
                modal: false
            }
        },
        methods: {
            Show() {
                this.$refs.verify.refresh();
                this.modal = true;
            },
            onSuccess() {
                this.$emit("success");
                this.modal = false;
            },
            onFail() {
                this.$emit("fail");
            },
            onRefresh() {
                this.$emit("refresh");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Verify.vue